import { reportReasonEnum } from "../enums/reportReasonEnum";
import api from "./BaseServices";

export interface ReportSchema {
  id: number;
  page: string;
  reason: reportReasonEnum;
  description: string;
  user_id: number;
  created_at: Date;
}

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/reports`; // Modify this if your API is on a different URL

// Function to fetch all preferences with pagination (limit and offset)

export const createReport = async (
  report: Omit<ReportSchema, "id" | "created_at" | "user_id">
): Promise<Boolean> => {
  const response = await api.post(`${API_URL}`, report, {
    withCredentials: true,
  });

  return response.data;
};
